import './index.scss'
$(".head li").eq(5).addClass("active")
$(window).scroll(function () {
    // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
    if ($(window).scrollTop()>=($(".news-details .banner").height() - 116) && $(window).scrollTop() <($(".other").offset().top - 100) ) {
        $(".news-page").addClass("fixed")
        $(".share").addClass("fixed")
    }else if($(window).scrollTop()>=($(".other").offset().top - 100)) {
        $(".news-page").removeClass("fixed")
        $(".share").removeClass("fixed")
    }
    else {
        $(".news-page").removeClass("fixed")
        $(".share").removeClass("fixed")
    }
})
